<template>
  <section>
    <button @click="isComponentModalActive = true" class="button is-light">
      {{ $t('nav.newMatchButton') }}
    </button>
    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <NewMatchForm/>
    </b-modal>
  </section>
</template>

<script>
import NewMatchForm from '@/components/NewMatchForm'
export default {
  components: {
    NewMatchForm
  },
  data () {
    return {
      isComponentModalActive: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NewMatchButton.vue